export const AADHAAR_RESPONSE_CONSTANTS = {
  // Query Parameters
  QUERY_PARAM_REDIRECT: 'redirect',
  QUERY_PARAM_TRUE: 'true',

  // Message Severities
  SEVERITY_ERROR: 'error',
  SEVERITY_WARN: 'warn',
  SEVERITY_SUCCESS: 'success',

  // Message Details
  MSG_INVALID_REDIRECT: 'Invalid redirect destination',
  MSG_INVALID_DOCUMENT: 'Invalid document format',
  MSG_EMAIL_COOLDOWN: 'Please wait',
  MSG_EMAIL_COOLDOWN_SUFFIX: 'seconds before sending again.',
  MSG_EMAIL_SUCCESS:
    'Signed document has been sent to your email successfully.',
  MSG_EMAIL_FAILED: 'Failed to send email. Please try again.',

  // Message Life (ms)
  MSG_LIFE_SHORT: 3000,
  MSG_LIFE_LONG: 3500,

  // Email Configuration
  NOTIFY_TYPE: 'ESIGN_SUCCESS',
  EMAIL_COOLDOWN_SECONDS: 10,

  // Timing (ms)
  REDIRECT_DELAY: 1000,
  SPINNER_DELAY: 1000,
  PRINT_LOAD_DELAY: 500,
  CLEANUP_DELAY: 100,
  FALLBACK_CLEANUP_DELAY: 60000,
  COOLDOWN_INTERVAL: 1000,

  // MIME Types
  MIME_TYPE_PDF: 'application/pdf',

  // Data URL
  DATA_URL_PDF_PREFIX: 'data:application/pdf;base64,',

  // Validation
  BASE64_PATTERN: /^[A-Za-z0-9+/]*={0,2}$/,
  PDF_HEADER: '%PDF',
  PDF_VALIDATION_LENGTH: 100,

  // Iframe Styles
  IFRAME_POSITION: 'fixed',
  IFRAME_RIGHT: '0',
  IFRAME_BOTTOM: '0',
  IFRAME_WIDTH: '0',
  IFRAME_HEIGHT: '0',
  IFRAME_BORDER: 'none',
  IFRAME_VISIBILITY: 'hidden',

  // File Download
  FILE_NAME_PREFIX: 'signed_document_',
  FILE_EXTENSION: '.pdf',
  SPACE_REPLACEMENT: '_',

  // Event Listeners
  EVENT_AFTERPRINT: 'afterprint',

  // Error Messages (Console)
  ERROR_EXTERNAL_SIGN_LINK: 'Error fetching external sign link:',
  ERROR_AADHAAR_DETAILS: 'Error fetching Aadhaar details:',
  ERROR_PRINT: 'Print error:',
  ERROR_DOWNLOAD: 'Error downloading document:',
};
